import { useSuspense } from "@api";
import type { IUser } from "@bbj-types/user";
import { useCallback } from "react";
import { axiosInstanceV2, axiosUserV2 } from "./axios";

export interface IUseGetUserResponse {
  users: IUser[];
  limit: number;
  skip: number;
  total: number;
  count: number;
}
export interface IAuthorQuery {
  name?: string;
  select?: string[];
  permissions?: string[] | string;
  organisation?: string;
  showDisabled?: boolean;
  _id?: string[];
}

export const useGetUserV2 = () => {
  const [state, execute, cancel] = axiosUserV2<IUseGetUserResponse, undefined, unknown>(
    {
      url: "",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query: IAuthorQuery) => {
      return execute({
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
export const useGetUserV2Suspense = (query: IAuthorQuery) => {
  return useSuspense(
    () =>
      axiosInstanceV2.get<IUseGetUserResponse>("", {
        withCredentials: true,
        params: query,
      }),
    [query._id, query.name, query.organisation, query.permissions, query.select, query.showDisabled]
  );
};
